import { Loader2 } from '@chain-zen/ui'

import type { TActiveAssetType } from '../../hooks/use-eld-asset-selection'

interface IAssetListSkeletonProps {
  activeAssetType: TActiveAssetType
}

/**
 * Loading skeleton for the asset list.
 * Displayed while assets are being fetched from the ELD provider.
 */
export const AssetListSkeleton = ({ activeAssetType }: IAssetListSkeletonProps) => {
  return (
    <div className="flex flex-col items-center justify-center py-10 gap-2.5">
      <Loader2 className="w-6 h-6 animate-spin text-muted-foreground" />
      <p className="text-sm text-muted-foreground">Loading {activeAssetType}s...</p>
    </div>
  )
}
